import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";

const Pagination = props => {
  const { onPageChange, currentPage, pagesCount } = props;
  if (
    pagesCount === 1 ||
    pagesCount === null ||
    pagesCount === undefined ||
    pagesCount === 0
  )
    return null;
  const pages = _.range(1, parseInt(pagesCount, 10) + 1);

  return (
    <React.Fragment>
      {pagesCount > 1 && (
        <nav>
          <ul className="pagination">
            {pagesCount > 4 && (
              <li className="page-item">
                <a className="page-link" onClick={() => onPageChange(1)}>
                  «
                </a>
              </li>
            )}
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => onPageChange(currentPage - 1)}
              >
                ‹
              </a>
            </li>
            {currentPage > 4 && (
              <li className="page-item">
                <a className="page-link">...</a>
              </li>
            )}
            {pages.map(
              (page, index) =>
                index < 5 + currentPage &&
                index > currentPage - 5 && (
                  <li
                    key={page}
                    className={
                      page === currentPage ? "page-item active" : "page-item"
                    }
                  >
                    <a className="page-link" onClick={() => onPageChange(page)}>
                      {page}
                    </a>
                  </li>
                )
            )}

            {currentPage < pagesCount - 5 && (
              <li className="page-item">
                <a className="page-link">...</a>
              </li>
            )}
            <li className="page-item">
              <a
                className="page-link"
                onClick={() => onPageChange(currentPage + 1)}
              >
                ›
              </a>
            </li>
            {pagesCount > 4 && (
              <li className="page-item">
                <a
                  className="page-link"
                  onClick={() => onPageChange(parseInt(pagesCount, 10))}
                >
                  »
                </a>
              </li>
            )}
          </ul>
        </nav>
      )}
    </React.Fragment>
  );
};

Pagination.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Common/pagination.jsx